// extracted by mini-css-extract-plugin
export var scrollArea = "_pw-0";